import type { BreadcrumbsFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Button, Link } from '@packages/shared';
import { ArrowMediumLeft32 } from '@packages/themes/icons';
import { createFilteredQueryStringWithSameOrder } from '../createFilteredQueryStringWithSameOrder';
import { createSearchQueryString } from '../createSearchQueryString';
import { extendedBreadcrumbsMessages } from '../messages';

export type ExtendedBreadcrumbsBackButtonProps = {
  breadCrumbData: NonNullable<BreadcrumbsFragmentFragment['breadCrumb']>;
};

export const ExtendedBreadcrumbsBackButton = ({
  breadCrumbData,
}: ExtendedBreadcrumbsBackButtonProps) => {
  const { formatMessage } = useIntl();
  const { query, asPath } = useRouter();
  const hasBreadcrumb = breadCrumbData.length > 0;
  const [rememberedBackLink, setRememberedBackLink] = useState<string>(
    hasBreadcrumb
      ? `${
          breadCrumbData[breadCrumbData.length - 1].uriPath
        }${createFilteredQueryStringWithSameOrder(asPath)}`
      : createSearchQueryString(asPath, query),
  );

  useEffect(() => {
    const pageData = window.sessionStorage.getItem('rememberedPageData');
    if (pageData) {
      const rememberedData = JSON.parse(pageData);
      setRememberedBackLink(rememberedData.path);
    }
  }, []);

  return (
    <Button LinkComponent={Link} href={rememberedBackLink} startIcon={<ArrowMediumLeft32 />}>
      {
        /** if there are no breadcrumbs (which is the case, if you come from a search result page - SERP),
         * there has to be a different button message
         * */
        formatMessage(
          hasBreadcrumb
            ? extendedBreadcrumbsMessages.backToMBA
            : extendedBreadcrumbsMessages.backToSERP,
        )
      }
    </Button>
  );
};
